<div class="form-content" [ngClass]="{'enduser-form-content': endUser}">
    <div *ngIf="!endUser" class="form-info">
        <div class="container padding-none">
            <div class="info-row row col-lg-12">
                <div class="info-col icon col-lg-1">
                    <div class="group-icon"></div>
                </div>
                <div class="info-col text col-lg-8">
                    <div class="info-title">SUPPORT ON DEMAND REQUEST</div>
                    <div class="info-desc">Once received your request will be reviewed for its completeness and you will receive a confirmation phone call to notify you of requested service scheduling time frame and or the need for additional info to fulfill your request. In order to process your request as soon as possible, please fill in all the information below.</div>
                </div>
                <div class="info-col col-lg-3 padding-left-none">
                    <div class="action-buttons">
                        <button class="btn action-btn submit" [ngClass]="{'setOpacity5': vinLoading || applicationFormValid}" (click)="(!vinLoading && !applicationFormValid) ? saveService() : false">{{submitText}}<span class="pi pi-check"></span></button>
                    </div>
                </div>
            </div>            
        </div>        
    </div>
    <div class="application-form">
        <form class="container" [formGroup]="applicationForm">
            <div class="field-row row col-lg-12" [ngClass]="{'hide': endUser}">
                <div class="col-lg-8 field-item padding-left-none">
                    <div class="label">Account Email <span *ngIf="businessExist" class="exist-text"><span class="pi pi-check"></span> Existing business found</span> <span class="required text-right">Required</span></div>
                    <div class="field p-input-icon-left">
                        <img class="inline-img" src="assets/images/repair-order/email-img.svg" onload="SVGInject(this)" alt="Account Email" />
                        <input pInputText class="input" placeholder="Enter email" formControlName="emailAddress" maxlength="70" (input)="onEmailChange($event.target.value)" [(ngModel)]="accountEmail" 
                        [ngClass]="{ 'is-invalid': applicationFormSubmit && apf.emailAddress.errors }" autocomplete="off" />
                        <div *ngIf="applicationFormSubmit && apf.emailAddress.errors" class="invalid-feedback">
                            <div *ngIf="apf.emailAddress.errors.required">Email is required</div>
                            <div *ngIf="!apf.emailAddress.errors.required && apf.emailAddress.errors">Invalid Email</div>
                        </div>
                    </div>
                </div>                
            </div>

            <div class="field-row row col-lg-12">
                <div class="row-head" [ngClass]="{'hide': endUser}">Direct Contact</div>
                <div class="col-lg-6 field-item padding-left-none" [ngClass]="{'hide': endUser}">
                    <div class="label">Select job title <span class="required">Required</span></div>
                    <div class="field drop-down">
                        <img class="inline-img" src="assets/images/repair-order/assignee-role.png" alt="Job Title" /> 
                        <p-dropdown appendTo="body" formControlName="jobTitle" [options]="jobTitleList" optionLabel="name" optionValue="id" (onChange)="fieldChange($event)"
                            placeholder="Job Title" [virtualScroll]="false" [itemSize]="5" [filter]="true" filterBy="name" resetFilterOnHide="true" [ngClass]="{ 'is-invalid': applicationFormSubmit && apf.jobTitle.errors }">
                            <ng-template pTemplate="selectedItem">
                                <div class="shop-item shop-item-value" *ngIf="selectedJobtitle">
                                    <div>{{selectedJobtitle.name}}</div>
                                </div>
                            </ng-template>
                            <ng-template let-jobTitleList pTemplate="item">
                                <div class="shop-item" *ngIf="jobTitleList.id == 0" (click)="$event.stopPropagation();serviceAction('new','jobTitle');">
                                    <div><span style="color: red;">{{jobTitleList.name}}</span></div>
                                </div>
                                <hr *ngIf="jobTitleList.value == 0">
                                <div class="option-item" *ngIf="jobTitleList.id > 0">{{jobTitleList.name}} <span *ngIf="jobTitleList.id > 0">ID#{{jobTitleList.id}}</span>
                                    <!--span *ngIf="shop.id > 0" class="edit" (click)="$event.stopPropagation();serviceAction('edit', 'shop', shop);">
                                        <img src="assets/images/edit-tag-img.png" alt="Edit">
                                    </span-->
                                </div>  
                            </ng-template>
                       </p-dropdown>
                        <div *ngIf="applicationFormSubmit && apf.jobTitle.errors" class="invalid-feedback">
                            <div *ngIf="apf.jobTitle.errors.required">Job Title is required</div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 field-item padding-left-none" [ngClass]="{'hide': endUser}">
                    <div class="label">First Name <span class="required">Required</span></div>
                    <div class="field p-input-icon-left">
                        <img class="inline-img" src="assets/images/repair-order/buss-cont-info-img.svg" onload="SVGInject(this)" alt="First Name" /> 
                        <input pInputText class="input" placeholder="Enter first name" formControlName="firstName" maxlength="70" 
                        [ngClass]="{ 'is-invalid': applicationFormSubmit && apf.firstName.errors }" autocomplete="off" />
                        <div *ngIf="applicationFormSubmit && apf.firstName.errors" class="invalid-feedback">
                            <div *ngIf="apf.firstName.errors.required">First name is required</div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 field-item padding-left-none" [ngClass]="{'hide': endUser}">
                    <div class="label">Last Name <span class="required">Required</span></div>
                    <div class="field p-input-icon-left">
                        <img class="inline-img" src="assets/images/repair-order/buss-cont-info-img.svg" onload="SVGInject(this)" alt="Last Name" /> 
                        <input pInputText class="input" placeholder="Enter last name" formControlName="lastName" maxlength="70" 
                        [ngClass]="{ 'is-invalid': applicationFormSubmit && apf.lastName.errors }" autocomplete="off" />
                        <div *ngIf="applicationFormSubmit && apf.lastName.errors" class="invalid-feedback">
                            <div *ngIf="apf.lastName.errors.required">Last name is required</div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 field-item padding-left-none" [ngClass]="{'hide': endUser}">
                    <div class="label">Contact Phone Number (Mobile) <span class="required">Required</span></div>
                    <div class="field p-input-icon-left">
                        <i class="pi pi-envelope"></i> 
                        <input type="text" class="hide form-control inputtext" matInput placeholder="012-345-6789" 
                        formControlName="contactPersonPhone" maxlength="15" 
                        [ngClass]="{ 'is-invalid': (applicationFormSubmit && (cphoneNumberValid || apf.contactPersonPhone.errors))}">
                        <div class="input-group" [ngClass]="{ 'active': cphonenoInputFlag, 'error': !cinvalidNumber }">
                            <div class="input-group-prepend phone-img normal"  [ngClass]="{ 'active': cphonenoInputFlag}"></div>
                            <ngx-intl-tel-input [cssClass]="'custom phone'" class="KA_input_text_Phone"
                                [preferredCountries]="preferredCountries" [(ngModel)]="contactPhoneValue"
                                [enableAutoCountrySelect]="true" [enablePlaceholder]="true"
                                [searchCountryFlag]="true" [phoneValidation]="true"
                                [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                                [selectFirstCountry]="true" [selectedCountryISO]="contactSelectedCountryIS0"
                                [maxLength]="15" [phoneValidation]="false"
                                [separateDialCode]="separateDialCode"
                                (countryChange)="onCountryChange('contactPhone',$event)"
                                (ngModelChange)="phoneNumberChange('contactPhone')"
                                [numberFormat]="PhoneNumberFormat.National" name="contactPhone"
                                formControlName="contactPersonPhone">
                            </ngx-intl-tel-input>
                        </div>
                        <div *ngIf="applicationFormSubmit && apf.contactPersonPhone.errors" class="invalid-feedback">
                            <div *ngIf="apf.contactPersonPhone.errors.required">Contact Phone number is required</div>
                        </div>
                        <div *ngIf="applicationFormSubmit && cphoneNumberValid" class="invalid-feedback">
                            <div id="valid-error" class="field-err">Invalid phone number</div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 field-item padding-left-none" [ngClass]="{'hide': endUser}">
                    <div class="label">Contact Email <span class="required">Required</span></div>
                    <div class="field p-input-icon-left">
                        <img class="inline-img" src="assets/images/repair-order/email-img.svg" onload="SVGInject(this)" alt="Contact Email" />
                        <input pInputText class="input" placeholder="Enter contact email" formControlName="emailAddress" maxlength="70" [ngModel]="accountEmail" disabled
                        [ngClass]="{ 'is-invalid': applicationFormSubmit && apf.emailAddress.errors }" autocomplete="off" />
                        <div *ngIf="applicationFormSubmit && apf.emailAddress.errors" class="invalid-feedback">
                            <div *ngIf="apf.emailAddress.errors.required">Contact Email is required</div>
                            <div *ngIf="!apf.emailAddress.errors.required && apf.emailAddress.errors">Invalid Email</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="field-row row col-lg-12">
                <div class="col-lg-8 field-item padding-left-none">
                    <div class="label">iSCAN SN (iSCAN 3 SN Starts # 4XXXX iSCAN SF SN Starts # 7XXXX) <span class="required text-right">Required</span></div>
                    <div class="field p-input-icon-left">
                        <img class="inline-img" src="assets/images/repair-order/vin-img.svg" onload="SVGInject(this)" alt="Iscan SN" />
                        <input pInputText class="input" placeholder="Enter iSCAN serial number" formControlName="iscanSn"
                        [ngClass]="{ 'is-invalid': applicationFormSubmit && apf.iscanSn.errors }" autocomplete="off" />
                        <div *ngIf="applicationFormSubmit && apf.iscanSn.errors" class="invalid-feedback">
                            <div *ngIf="apf.iscanSn.errors.required">iSCAN serial number is required</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="field-row row col-lg-12" [ngClass]="{'hide': endUser}">
                <div class="col-lg-4 field-item padding-left-none">
                    <div class="label">Best Contact Phone Number (Mobile) <span class="required text-right">Required</span></div>
                    <div class="field p-input-icon-left">
                        <i class="pi pi-envelope"></i> 
                        <input type="text" class="hide form-control inputtext" matInput placeholder="012-345-6789" 
                        formControlName="phone" maxlength="15" [ngClass]="{ 'is-invalid': (applicationFormSubmit && (phoneNumberValid || apf.phone.errors))}">
                        <div class="input-group" [ngClass]="{ 'active': phonenoInputFlag, 'error': !invalidNumber }">
                            <div class="input-group-prepend phone-img normal"  [ngClass]="{ 'active': phonenoInputFlag}"></div>
                            <ngx-intl-tel-input [cssClass]="'custom phone'" class="KA_input_text_Phone"
                                [preferredCountries]="preferredCountries" [(ngModel)]="phoneValue"
                                [enableAutoCountrySelect]="true" [enablePlaceholder]="true"
                                [searchCountryFlag]="true" [phoneValidation]="true"
                                [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                                [selectFirstCountry]="true" [selectedCountryISO]="selectedCountryIS0"
                                [maxLength]="15" [phoneValidation]="false"
                                [separateDialCode]="separateDialCode"
                                (countryChange)="onCountryChange('phone',$event)"
                                (ngModelChange)="phoneNumberChange('phone')"
                                [numberFormat]="PhoneNumberFormat.National" name="phone"
                                formControlName="phone">
                            </ngx-intl-tel-input>
                        </div>
                        <div *ngIf="applicationFormSubmit && apf.phone.errors" class="invalid-feedback">
                            <div *ngIf="apf.phone.errors.required">Phone number is required</div>
                        </div>
                        <div *ngIf="applicationFormSubmit && phoneNumberValid">
                            <div id="valid-error" class="field-err">Invalid phone number</div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 field-item padding-left-none">
                    <div class="label">Business Name <span class="required text-right">Required</span></div>
                    <div class="field p-input-icon-left">
                        <img class="inline-img" src="assets/images/repair-order/buss-info.svg" onload="SVGInject(this)" alt="Business Name" />
                        <input pInputText class="input" placeholder="Enter business name" formControlName="businessName" maxlength="70" 
                        [ngClass]="{ 'is-invalid': applicationFormSubmit && apf.businessName.errors }" autocomplete="off" />
                        <div *ngIf="applicationFormSubmit && apf.businessName.errors" class="invalid-feedback">
                            <div *ngIf="apf.businessName.errors.required">Business name is required</div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 field-item padding-left-none">
                    <div class="label">Shop Number</div>
                    <div class="field p-input-icon-left">
                        <img class="inline-img" src="assets/images/repair-order/job-desc.png" alt="Shop Number" /> 
                        <input pInputText class="input" placeholder="Enter shop number" formControlName="customerId" maxlength="70" autocomplete="off" />
                    </div>
                </div>
            </div>

            <div class="field-row row col-lg-12" [ngClass]="{'hide': endUser}">
                <div class="col-lg-4 field-item padding-left-none">
                    <div class="label">Shop Repair Order Number or Invoice#</div>
                    <div class="field p-input-icon-left">
                        <img class="inline-img" src="assets/images/repair-order/order-number-img.svg" onload="SVGInject(this)" alt="Order Number" />
                        <input pInputText class="input" placeholder="Enter shop repair order number" formControlName="orderNumber" maxlength="70" autocomplete="off" />
                    </div>
                </div>
                <div class="col-lg-4 field-item padding-left-none">
                    <div class="label">Billing Email</div>
                    <div class="field p-input-icon-left">
                        <img class="inline-img" src="assets/images/repair-order/email-img.svg" onload="SVGInject(this)" alt="Billing Email" />
                        <input pInputText class="input" placeholder="Enter billing email" formControlName="billingEmail" maxlength="70" 
                        [ngClass]="{ 'is-invalid': applicationFormSubmit && apf.billingEmail.errors }" autocomplete="off" />
                        <div *ngIf="applicationFormSubmit && apf.billingEmail.errors" class="invalid-feedback">
                            <div *ngIf="apf.billingEmail.errors">Invalid Email</div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 field-item padding-left-none">
                    <div class="label">Time Zone</div>
                    <div class="field drop-down">
                        <img class="inline-img" src="assets/images/repair-order/time-zone.svg" onload="SVGInject(this)" alt="Time Zone" /> 
                        <p-dropdown appendTo="body" [options]="timeZoneList" optionLabel="name" formControlName="appointmentTimeZone" optionValue="id" 
                        placeholder="Time Zone" [virtualScroll]="false" [itemSize]="5" [filter]="true" resetFilterOnHide="true">
                       </p-dropdown>
                    </div>
                </div>
            </div>

            <div class="field-row row col-lg-12">
                <div class="section-row">
                    <div class="section-head">SOD Request Guideline</div>
                    <div class="section-desc">Please choose from the following options below regarding our request guidelines.</div>
                </div>
                <div class="label">Support Request Type <span class="required text-right">Required</span></div>
                <div class="col-lg-4 field-item field-radio padding-left-none" [ngClass]="{'check-box-1': rti == 0}" *ngFor="let requestTypeOpt of requestTypeOptions; let rti = index;">
                    <div class="custom-radio">
                        <input id="{{requestTypeOpt}}" name="requestType" type="radio" class="custom-control-input" value="{{requestTypeOpt}}" formControlName="srequestType" [ngClass]="{ 'is-invalid': applicationFormSubmit && apf.srequestType.errors }">
                        <label class="custom-control-label" for="{{requestTypeOpt}}">{{requestTypeOpt}}</label>
                    </div>
                </div>
                <div class="col-lg-12 notes padding-left-none">
                    <span>Note: After hours and expedited service may incur additional charges. Thank you for your understanding.</span>
                </div>
                <div *ngIf="applicationFormSubmit && apf.srequestType.errors" class="invalid-feedback">
                    <div *ngIf="apf.srequestType.errors.required">Support Request Type is required</div>
                </div>
            </div>

            <div class="field-row row col-lg-12">
                <div class="label">Support Service Type (Please select all service needed for your request ✔) <span class="required text-right">Required</span></div>
                <div class="col-lg-3 field-item field-radio padding-left-none" [ngClass]="{'check-box-1': stoi == 0}" *ngFor="let st of serviceTypeOptions; let stoi = index;">
                    <div class="custom-checkbox">
                        <input id="{{st.name}}" name="serviceType" type="checkbox" class="custom-control-input" formControlName="serviceType" (change)="onCheckboxChange('serviceType', stoi, $event)" [ngClass]="{ 'is-invalid': applicationFormSubmit && apf.serviceType.errors }">
                        <label class="custom-control-label" for="{{st.name}}">{{st.name}}</label>
                    </div>
                </div>
                <div *ngIf="applicationFormSubmit && apf.serviceType.errors" class="invalid-feedback">
                    <div *ngIf="apf.serviceType.errors.required">Support Service Type is required</div>
                </div>
            </div>

            <div class="field-row row vin-row col-lg-12">
                <div class="col-lg-3 field-item padding-left-none">
                    <div class="label">VIN <span class="required">Required</span></div>
                    <div class="field drop-down">
                        <img class="inline-img" src="assets/images/repair-order/vin-img.svg" onload="SVGInject(this)" alt="VIN" />
                        <input pInputText class="input" placeholder="Enter VIN number" formControlName="vin" maxlength="17" [readonly]="vinLoading" (input)="vinChanged('change', $event.target.value)"
                        [ngClass]="{ 'is-invalid': applicationFormSubmit && apf.vin.errors }" autocomplete="off" />
                        <div *ngIf="vinLoading" class="cust-loader svcm-loader"><img src="assets/images/landing-page/loading-more.svg" alt="Loader" /></div>
                        <div *ngIf="applicationFormSubmit && apf.vin.errors" class="invalid-feedback">
                            <div *ngIf="apf.vin.errors.required">VIN number is required</div>
                        </div>
                        <div *ngIf="!vinLoading && vinIsValid && !vinValid" class="invalid-feedback invalid-field">
                            <div id="valid-error" class="field-err">invalid VIN</div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 field-item padding-left-none">
                    <div class="label">Make <span class="required">Required</span></div>
                    <div class="field p-input-icon-left">
                        <img class="inline-img" src="assets/images/repair-order/make-img.svg" onload="SVGInject(this)" alt="Make" /> 
                        <input pInputText class="input" placeholder="Enter make" formControlName="make" maxlength="70" readonly="makeDisable" 
                        [ngClass]="{ 'is-invalid': applicationFormSubmit && apf.make.errors }" autocomplete="off" />
                        <div *ngIf="vinLoading" class="cust-loader svcm-loader"><img src="assets/images/landing-page/loading-more.svg" alt="Loader" /></div>
                        <div *ngIf="applicationFormSubmit && apf.make.errors" class="invalid-feedback">
                            <div *ngIf="apf.make.errors.required">Make is required</div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 field-item padding-left-none">
                    <div class="label">Model <span class="required">Required</span></div>
                    <div class="field p-input-icon-left">
                        <img class="inline-img" src="assets/images/repair-order/model-img.svg" onload="SVGInject(this)" alt="Model" />
                        <input pInputText class="input" placeholder="Enter model" formControlName="model" maxlength="70" readonly="modelDisable"
                        [ngClass]="{ 'is-invalid': applicationFormSubmit && apf.model.errors }" autocomplete="off" />
                        <div *ngIf="vinLoading" class="cust-loader svcm-loader"><img src="assets/images/landing-page/loading-more.svg" alt="Loader" /></div>
                        <div *ngIf="applicationFormSubmit && apf.model.errors" class="invalid-feedback">
                            <div *ngIf="apf.model.errors.required">Model is required</div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 field-item padding-left-none">
                    <div class="label">Year <span class="required">Required</span></div>
                    <div class="field p-input-icon-left">
                        <img class="inline-img" src="assets/images/repair-order/year-img.svg" onload="SVGInject(this)" alt="Year" />
                        <input pInputText class="input" placeholder="Enter year" formControlName="year" maxlength="70" readonly="yearDisable"
                        [ngClass]="{ 'is-invalid': applicationFormSubmit && apf.year.errors }" autocomplete="off" />
                        <div *ngIf="vinLoading" class="cust-loader svcm-loader"><img src="assets/images/landing-page/loading-more.svg" alt="Loader" /></div>
                        <div *ngIf="applicationFormSubmit && apf.year.errors" class="invalid-feedback">
                            <div *ngIf="apf.year.errors.required">Year is required</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="field-row row col-lg-12">
                <div class="section-row">
                    <div class="section-head">Coding / Programming Request</div>
                </div>
            </div>

            <div class="field-row row col-lg-12 padding-none">
                <div class="label">Coding / Programming service for</div>
                <div class="col-lg-3 field-item field-radio padding-left-none" [ngClass]="{'check-box-1': i == 0}" *ngFor="let so of serviceOptions; let i = index">
                    <div class="custom-checkbox">
                        <input id="{{so.name}}" name="serviceRequest" type="checkbox" class="custom-control-input" value="{{so.name}}" formControlName="serviceRequest" (change)="onCheckboxChange('serviceRequest', i, $event)">
                        <label class="custom-control-label" for="{{so.name}}">{{so.name}}</label>
                    </div>
                </div>
            </div>

            <div class="field-row row vin-row col-lg-12">
                <div class="label">New Replacement Module Detail</div>
                <div class="col-lg-3 field-item field-radio padding-left-none" [ngClass]="{'check-box-1': ci == 0}" *ngFor="let co of conditionOptions; let ci = index">
                    <div class="custom-checkbox">
                        <input id="{{co.name}}" name="replacementModule" type="checkbox" class="custom-control-input" value="{{co.name}}" formControlName="replacementModule" (change)="onCheckboxChange('replacementModule', ci, $event)">
                        <label class="custom-control-label" for="{{co.name}}">{{co.name}}</label>
                    </div>
                </div>
                <div class="col-lg-12 notes padding-left-none">
                    <span>In some cases, it may be necessary to read or transfer coding from the originally installed module prior to installing the replacement.</span>
                </div>
            </div>

            <div class="field-row row col-lg-12">
                <div class="row-head">Control Unit Description</div>
                <div class="col-lg-1 field-item field-label padding-left-none ">ECU</div>
                <div class="col-lg-4 field-item padding-left-none">
                    <div class="label">System<span class="required hide">Required</span></div>
                    <div class="field p-input-icon-left">
                        <img class="inline-img" src="assets/images/parts/system-icon.png" alt="System">
                        <input pInputText class="input" placeholder="Enter system" formControlName="ecuSystem" maxlength="70"
                        [ngClass]="{ 'is-invalid': applicationFormSubmit && apf.ecuSystem.errors }"
                        autocomplete="off" />
                        <div *ngIf="applicationFormSubmit && apf.ecuSystem.errors" class="invalid-feedback">
                            <div *ngIf="apf.ecuSystem.errors.required">System is required</div>
                        </div>
                    </div>
                   
                </div>
                <div class="col-lg-4 field-item padding-left-none">
                    <div class="label">Module <span class="required hide">Required</span></div>
                    <div class="field p-input-icon-left">
                        <img class="inline-img" src="assets/images/documents/category.png" alt="Module" />
                        <input pInputText class="input" placeholder="Enter module" formControlName="ecuModule" maxlength="70" 
                        [ngClass]="{ 'is-invalid': applicationFormSubmit && apf.ecuModule.errors }"
                        autocomplete="off" />
                        <div *ngIf="applicationFormSubmit && apf.ecuModule.errors" class="invalid-feedback">
                            <div *ngIf="apf.ecuModule.errors.required">Module is required</div>
                        </div>
                    </div>
                    
                </div>
                <div class="col-lg-12 notes padding-left-none">
                    <span>*Please make sure to install the correct part/ECU for your vehicle in working condition. Please provide the additional ECU info above If further confirmation is need from our SOD OE specialist.</span>
                </div>
            </div>

            <div class="field-row row col-lg-12">
                <div class="row-head">Original ECU Module</div>
                <div class="label lable-row-1 col-lg-4 padding-left-none">Still present & communicates?</div>
                <div class="field-item split-check-item split-check-item-{{i}} col-md-2 col-sm-2" [ngClass]="{'check-box-1': i == 0, 'col-lg-2': i >= 1}" *ngFor="let co of communicationOptions; let i = index">
                    <div class="custom-checkbox text-center margin-bottom-align top-align">
                        <div class="checkbox-label" [ngClass]="{'left-align': i != 1}">{{co.name}}</div>
                        <input id="{{co.name}}" name="presentCommunicate" type="radio" class="custom-control-input" value="{{co.name}}" formControlName="presentCommunicate" (click)="checkChange(i)">
                        <label class="custom-control-label" for="{{co.name}}"></label>
                    </div>
                </div>
            </div>

            <div class="field-row row col-lg-12 padding-none">
                <div class="label col-lg-4 padding-left-none">Any previous programming attempt made?</div>
                <div class="field-item split-check-item split-check-item-{{i}} col-md-2 col-sm-2" [ngClass]="{'check-box-1': i == 0, 'col-lg-2': i >= 1}" *ngFor="let po of prevAttemptOptions; let i = index">
                    <div class="custom-checkbox text-center margin-bottom-align">
                        <input id="{{po.name}}" name="prevProgrammingAttempt" type="radio" class="custom-control-input" value="{{po.name}}" formControlName="prevProgrammingAttempt" (click)="checkChange(i)">
                        <label class="custom-control-label" for="{{po.name}}"></label>
                    </div>
                </div>
            </div>

            <div *ngIf="ecuAdditionalFieldFlag" class="field-row row col-lg-12">
                <div class="col-lg-5 field-item padding-left-none">
                    <div class="label">Which tool and or provider was used for this programming event?</div>
                    <div class="field p-input-icon-left">
                        <img class="inline-img" src="assets/images/repair-order/iscan-tool-provider-icon.svg" onload="SVGInject(this)" alt="Provider" />
                        <p-dropdown appendTo="body" formControlName="provider" [options]="toolOptions" optionLabel="name" optionValue="name" (onChange)="changeItem('tool',$event)"
                            placeholder="Select Tool" [virtualScroll]="false" [itemSize]="5" [filter]="true" filterBy="name" resetFilterOnHide="true" [ngClass]="{ 'is-invalid': applicationFormSubmit && apf.provider.errors }">
                       </p-dropdown>
                        <div *ngIf="applicationFormSubmit && apf.provider.errors" class="invalid-feedback">
                            <div *ngIf="apf.provider.errors.required">Provider tool is required</div>
                        </div>
                    </div>
                </div>               
            </div>

            <div *ngIf="ecuAdditionalFieldFlag" class="field-row row col-lg-12">
                <div class="col-lg-5 field-item padding-left-none">
                    <div class="label">Do you have a preferred support provider you'd like to work with?</div>
                    <div class="field p-input-icon-left">
                        <img class="inline-img" src="assets/images/repair-order/buss-cont-info-img.svg" onload="SVGInject(this)" alt="Support Provider" /> 
                        <input pInputText class="input" placeholder="Enter support provider" formControlName="supportProvider" maxlength="70" 
                        [ngClass]="{ 'is-invalid': applicationFormSubmit && apf.supportProvider.errors }" autocomplete="off" />
                        <div *ngIf="applicationFormSubmit && apf.supportProvider.errors" class="invalid-feedback">
                            <div *ngIf="apf.supportProvider.errors.required">Support provider is required</div>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="ecuAdditionalFieldFlag" class="field-row row col-lg-12 padding-none">
                <div class="label col-lg-12 padding-left-none">Vehicle Condition</div>
                <div class="field-item split-check-item split-check-item-{{i}} vc-check-item col-md-4 col-sm-4" *ngFor="let vco of vehicleConditionOptions; let i = index">
                    <div class="custom-checkbox margin-bottom-align">
                        <input id="{{vco.name}}" name="vehicleCondition" type="radio" class="custom-control-input" value="{{vco.name}}" formControlName="vehicleCondition">
                        <label class="custom-control-label" for="{{vco.name}}">{{vco.name}}</label>
                    </div>
                </div>
            </div>

            <div class="field-row row col-lg-12">
                <div class="col-lg-12 field-item padding-left-none">
                    <div class="label">
                        <img src="assets/images/repair-order/prob-desc.svg" onload="SVGInject(this)" alt="Problem Description" />
                        <span class="editor-label">Customers Original Complaint</span>
                        <span class="required">Required</span>
                    </div>
                    <div  style="width:99%;">
                        <ckeditor class="editor-desc-green" [ngClass]="{ 'editor-desc-red' : customerComplaintFlag }" [editor]="Editor" [config]="complaintConfigCke" container="body"
                        formControlName="customerComplaint" (change)="onChange('customerComplaint')"                                
                        [(ngModel)]="customerComplaint"></ckeditor>
                    </div>
                    <div class="service-form-error-row" *ngIf="customerComplaintFlag" style="margin:-15px 0 15px 0;">Customers Original Complaint</div>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 row no-margin padding-none">  
                    <div class="attach-row-lt mtop17 label-head-row-1 flex-align-center" [ngClass]="{'attach-row-lt-log': endUser}">
                        <img src="assets/images/repair-order/attachments-img.svg" onload="SVGInject(this)" alt="Attachments" />
                        <span>Attachments</span>
                    </div>
                    <div class="attach-row-rt cursor-pointer" (click)="attachmentPopup(0,'new');" [ngClass]="{'attach-row-rt-log': endUser}">
                        <span class="attach-text"><img src="assets/images/bug-details/attachment.png" alt="Attachments" />&nbsp;Attach Files</span>
                        <span class="attach-count" *ngIf="commentUploadedItemsFlag">{{commentUploadedItemsLength}}</span>
                    </div> 
                    <div class="attachment-row" *ngIf="postUploadActionTrue" [ngClass]="{'reference-info-hide': postUploadActionTrue }" >
                        <app-file-attachment *ngIf="postUpload" class="attachment-file" [action]="manageAction" [apiData]="postApiData" (uploadedItems)="attachments($event)"></app-file-attachment>
                    </div>   
                </div>
            </div>

            <div class="field-row row col-lg-12">
                <div class="col-lg-12 field-item padding-left-none">
                    <div class="label dtc"><img class="inline-img" src="assets/images/common/engine-icon.png" alt="DTC" /> [DTC] Please provide fault codes when available</div>
                    <div class="field p-input-icon-left">
                        <input pInputText class="input dtc" placeholder="Enter DTC" formControlName="dtc" maxlength="70" 
                        [ngClass]="{ 'is-invalid': applicationFormSubmit && apf.dtc.errors }" autocomplete="off" />
                        <div *ngIf="applicationFormSubmit && apf.dtc.errors" class="invalid-feedback">
                            <div *ngIf="apf.dtc.errors.required">DTC is required</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="field-row row col-lg-12">
                <div class="col-lg-12 field-item padding-left-none">
                    <div class="label">
                        <img src="assets/images/repair-order/prob-desc.svg" onload="SVGInject(this)" alt="Problem Description" />
                        <span class="editor-label">Repair / Work History Details</span>
                        <span class="required">Required</span>
                    </div>
                    <div  style="width:99%;">
                        <ckeditor class="editor-desc-green" [ngClass]="{ 'editor-desc-red' : repairHistoryFlag }" [editor]="Editor" [config]="repairOrderHistoryConfigCke" container="body"
                        formControlName="repairHistory" (change)="onChange('repairHistory')"                               
                        [(ngModel)]="repairHistory"></ckeditor>
                    </div>
                    <div class="service-form-error-row" *ngIf="repairHistoryFlag">Repair / Work History Details</div>
                </div>
            </div>

            <div class="field-row row col-lg-12">
                <div class="col-lg-12 field-item padding-left-none">
                    <div class="label">
                        <img src="assets/images/repair-order/prob-desc.svg" onload="SVGInject(this)" alt="Problem Description" />
                        <span class="editor-label">Please List Any Warning Lights /Messages On</span>
                    </div>
                    <div  style="width:99%;">
                        <ckeditor class="editor-desc-green" [ngClass]="{ 'editor-desc-red' :warningInfoFlag }" [editor]="Editor" [config]="warningConfigCke" container="body"
                        formControlName="warningInfo" (change)="onChange('warningInfo')"                               
                        [(ngModel)]="warningInfo"></ckeditor>
                    </div>
                    <div class="service-form-error-row" *ngIf="warningInfoFlag">Please List Any Warning Lights /Messages On</div>
                </div>
            </div>

            <div class="field-row row col-lg-12">
                <div class="col-lg-5 field-item padding-left-none">
                    <div class="label insurance"><img class="inline-img" src="assets/images/common/insurance-icon.png" alt="Insurance" /> Insurance Document Requested</div>
                    <div class="field p-input-icon-left">                        
                        <p-dropdown appendTo="body" class="insurance" formControlName="insurance" [options]="insuranceOptions" optionLabel="name" optionValue="name"
                            placeholder="Select" [virtualScroll]="false" [itemSize]="5" [filter]="true" filterBy="name" resetFilterOnHide="true" [ngClass]="{ 'is-invalid': applicationFormSubmit && apf.insurance.errors }">
                       </p-dropdown>
                        <div *ngIf="applicationFormSubmit && apf.insurance.errors" class="invalid-feedback">
                            <div *ngIf="apf.insurance.errors.required">Insurance is required</div>
                        </div>
                    </div>
                </div>               
            </div>

            <div class="field-row row col-lg-12">
                <div class="col-lg-12 field-item padding-left-none">
                    <div class="label">
                        <img src="assets/images/repair-order/prob-desc.svg" onload="SVGInject(this)" alt="Preferred provider request" />
                        <span class="editor-label">Preferred provider request</span>
                    </div>
                    <div  style="width:99%;">
                        <ckeditor class="editor-desc-green" [ngClass]="{ 'editor-desc-red': providerRequestFlag }" [editor]="Editor" [config]="providerRequestConfigCke" container="body"
                        formControlName="providerRequest" (change)="onChange('providerRequest')"                               
                        [(ngModel)]="providerRequest"></ckeditor>
                    </div>
                    <div class="service-form-error-row" *ngIf="providerRequestFlag">Preferred provider request</div>
                </div>
                <div *ngIf="!endUser" class="col-lg-12 notes padding-left-none">
                    <span>Working with someone special? Tell us who you prefer. Name or Email of our Team Member</span>
                </div>
                <div *ngIf="!endUser" class="col-lg-12 support-text padding-left-none">
                    To ensure successful support session, please see our <span class="vehicle-condition">test setup requirements.</span>
                </div>
            </div>
            
            <div *ngIf="!endUser" class="field-row row col-lg-12">
                <div class="section-row">
                    <div class="section-head">Payment Method</div>
                    <div class="section-desc">Initial Diagnostic Charge: (Obtained based on vehicle type entered). Additional charges may apply, depending on diagnostic time needed.</div>
                </div>
                <div class="row-head">Enter Credit Card Information</div>
                <div class="row col-lg-12">
                    <div class="form-field col-4 padding-left-none">
                        <div class="field-card-row">
                            <div class="field-card-col label">Card Holder Name <span class="required text-right">Required</span></div>
                        </div>
                        <div class="field-item card-name">
                            <img class="inline-img" src="assets/images/repair-order/buss-cont-info-img.svg" onload="SVGInject(this)" alt="First Name" /> 
                            <input pInputText placeholder="Enter cardholder name" formControlName="cardHolderName" maxlength="50" [ngClass]="{ 'is-invalid': applicationFormSubmit && apf.cardHolderName.errors }">
                            <div *ngIf="applicationFormSubmit && apf.cardHolderName.errors" class="invalid-feedback">
                                <div *ngIf="apf.cardHolderName.errors.required">Cardholder name is required</div>
                            </div>
                        </div>
                    </div>
                    <div class="form-field col-4">
                        <div class="field-card-row">
                            <div class="field-card-col label">Card Number</div>
                            <div class="field-card-col stripe"></div>
                        </div>
                        <div class="form-field">
                            <div class="stripe-card-box-outer field-item">
                                <stripe-card #stripeCard
                                [options]="stripeOptions"
                                (catch) = "onStripeError($event)"
                                [(complete)] = "cardDetailsFilledOut"
                                [(invalid)] = "invalidError"
                                (cardMounted) = "cardCaptureReady = 1"
                                (paymentMethodChange) = "setStripePaymentMethod($event)"
                                (tokenChange) = "setStripeToken($event)"
                                (invalidChange) = "onStripeInvalid($event)"
                                (changed) = "onStripeChanged($event)"
                                (sourceChange) = "setStripeSource($event)"
                            ></stripe-card>
                            </div>
                            <span *ngIf="showCardError && !cardDetailsFilledOut && stripeError" class="error-msg">{{stripeError}}</span>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="field-row row col-lg-12">
                <div *ngIf="!endUser" class="col-lg-10 field-item padding-left-none check-box-1">
                    <div class="terms-cond">Terms and Conditions</div>
                    <div class="custom-checkbox">
                        <input id="terms" name="terms" type="checkbox" class="custom-control-input" value="{{terms}}" formControlName="terms" [ngClass]="{ 'is-invalid': applicationFormSubmit && apf.terms.errors }">
                        <label class="custom-control-label" for="terms">I accept the Terms and Conditions</label>
                    </div>
                    <div *ngIf="applicationFormSubmit && apf.terms.errors" class="invalid-feedback">
                        <div *ngIf="apf.terms.errors">Terms and Condiction is required</div>
                    </div>
                </div>
                <div class="field-item padding-left-none" [ngClass]="{'col-lg-12': endUser, 'col-lg-2': !endUser}">
                    <div class="action-buttons" [ngClass]="{'action-buttons-log': endUser}">
                        <button class="btn action-btn submit" [ngClass]="{'setOpacity5': vinLoading || applicationFormValid}" (click)="(!vinLoading && !applicationFormValid) ? saveService() : false">{{submitText}}<span class="pi" [ngClass]="{'pi-check': !endUser, 'pi-angle-right': endUser}"></span></button>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <div *ngIf="!endUser" class="container footer-area">
        <div class="container padding-none">
            <div class="text-co">&copy; Collabtic {{year}}. All rights reserved.</div>
        </div>
    </div>
</div>

<p-dialog [header]="false" [(visible)]="successFlag" closeOnEscape="false" [closable]="false" [modal]="true" styleClass="p-fluid ro-success-msg-dialog-popup"> 
    <div class="automated-msg-container">  
        <div class="green-div">
            <div>
                <img src="assets/images/repair-order/ro-success-tick.png">  
            </div>
            <div>
                <div class="text-1">Your support request has been submitted.</div>
                <div class="text-2 ro-number">RO# is {{workOrderId}}</div>
            </div>
        </div>  
        <div class="white-div">     
            <div>          
                <p class="text-3">We will contact you shortly.</p>
            </div> 
            <div class="cursor btn-div" (click)="redirectionURL()">
                <img src="assets/images/tick-active.png"><span>OK</span>                
            </div>
        </div>    
    </div>  
</p-dialog>

<p-dialog [(visible)]="vinDisplayModal" [modal]="true" [closeOnEscape]="dialogEscClose" [closable]="dialogClose" [draggable]="false" [resizable]="true"
    class="dialog-modal dispatch-modal">
    <ng-template pTemplate="diglog-cont">
        <div class="diglog-img" [ngClass]="{'scan': dialogLoader, 'error': !dialogLoader}"></div>
        <div class="diglog-msg text-center">{{dialogContent}}</div>
        <div *ngIf="dialogLoader" class="dialog-loader text-center">
            <img src="assets/images/common/dialog-loader.svg" alt="Loader" />
        </div>
    </ng-template>
</p-dialog>

<p-dialog [(visible)]="submitModal" [modal]="true" [closeOnEscape]="submitDialogEscClose" [closable]="submitDialogClose" [draggable]="false" [resizable]="true"
    class="dialog-modal dispatch-modal form-submit-modal">
    <ng-template pTemplate="diglog-cont">
        <div class="diglog-msg text-center">{{submitDialogContent}}</div>
    </ng-template>
</p-dialog>